import React, { useEffect } from 'react';
import {
  QuoteInformationContainer,
  QuoteInformationItem,
} from '../../ResultPageComponents/v2/RiskCard.styles';
import { monopattiniPackage } from '../../../../constants';

function RiskQuoteInfoComponent({
  quote, type, setExtraText, requestInfo,
}) {
  useEffect(() => {
    setExtraText(
      `${quote.risk_massimale !== null
        && quote.risk_massimale !== undefined
        && quote.risk_massimale != 0
        ? `Massimale: ${quote.risk_massimale}`
        : ''
      }  ${quote.massimale !== null
        && quote.massimale !== undefined
        && quote.massimale != 0
        ? `Massimale: ${quote.massimale}`
        : ''
      } Frequenza pagamento: ${quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'
      } ${quote.product_id !== 10 && quote.product_name
        ? `Nome Prodotto: ${quote.product_name}`
        : ''
      } ${quote.product_id === 10
        && quote.product_name
        && quote.quote_type === 'tutela_legale'
        ? `Nome Prodotto: ${quote.product_name}`
        : ''
      }`,
    );
  }, [quote, type]);
  return (
    <>
      <QuoteInformationContainer>
        <QuoteInformationItem>
          <h6>Compagnia:</h6>
          <p>{quote.company.name}</p>
        </QuoteInformationItem>
        {(quote.product_id !== 1002 && quote.product_id !== 1003)
          && (
            <QuoteInformationItem>
              <h6>Prodotto:</h6>
              <p>{type.name}</p>
            </QuoteInformationItem>
          )}
        {(quote.product_id === 1002 || quote.product_id === 1003)
          && (
            <QuoteInformationItem>
              <h6>Prodotto:</h6>
              <p>{requestInfo.product.name}</p>
            </QuoteInformationItem>
          )}
        <QuoteInformationItem>
          <h6>Emissione:</h6>
          <p>Tradizionale</p>
        </QuoteInformationItem>
        <QuoteInformationItem>
          <h6>Frequenza pagamento:</h6>
          <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
        </QuoteInformationItem>
      </QuoteInformationContainer>
      <QuoteInformationContainer>
        {quote.risk_massimale
          && quote.risk_massimale !== null
          && quote.risk_massimale != '0.00' && quote.company_id !== 18 && (
            <QuoteInformationItem>
              <h6>Massimale:</h6>
              <p>
                {/* {quote.risk_massimale} */}
                {Number(quote.risk_massimale).toLocaleString('it-IT', {
                  minimumFractionDigits: 2,
                })}
                &euro;
              </p>
            </QuoteInformationItem>
        )}
        {quote.risk_massimale
          && quote.risk_massimale !== null
          && quote.risk_massimale != '0.00' && quote.company_id === 18 && (
            <QuoteInformationItem>
              <h6>Massimale:</h6>
              <p>
                {quote.risk_massimale}
              </p>
            </QuoteInformationItem>
        )}
        {quote.massimale
          && quote.massimale !== null
          && quote.massimale != '0.00' && quote.company_id === 18 && (
            <QuoteInformationItem>
              <h6>Massimale:</h6>
              <p>
                {quote.massimale}
              </p>
            </QuoteInformationItem>
        )}
        {quote.massimale !== null && quote.massimale != '0.00' && quote.company_id !== 18 && quote.product_id !== 11 && (
          <QuoteInformationItem>
            <h6>Massimale:</h6>
            <p>
              {Number.isNaN(Number(quote.massimale).toLocaleString('it-IT', {
                minimumFractionDigits: 2,
              })) ? quote.massimale : `${Number(quote.massimale).toLocaleString('it-IT', {
                  minimumFractionDigits: 2,
                })} €`}
            </p>
          </QuoteInformationItem>
        )}
        {quote.massimale !== null && quote.massimale != '0.00' && quote.company_id !== 18 && quote.product_id === 11 && (
          <QuoteInformationItem>
            <h6>Massimale:</h6>
            <p>
              {quote.quote_type === 'extra_incendio_fabbricato'
                ? `${Number(quote.massimale).toLocaleString('it-IT', { minimumFractionDigits: 0 })} €`
                : quote.massimale}
            </p>
          </QuoteInformationItem>
        )}
        {quote.product_id !== 10 && quote.product_id !== 11 && quote.product_id !== 1002 && quote.product_name && (
          <QuoteInformationItem>
            <h6>Nome Prodotto:</h6>
            <p>{quote.product_name}</p>

          </QuoteInformationItem>

        )}

        {quote.product_id === 1002 && (
          <QuoteInformationItem>
            <h6>Nome Prodotto:</h6>
            <p>{quote.product_name}</p>
          </QuoteInformationItem>
        )}

        {quote.product_id === 10
          && quote.product_name
          && quote.quote_type === 'tutela_legale' && (
            <QuoteInformationItem>
              <h6>Nome Prodotto:</h6>
              <p>{quote.product_name}</p>
            </QuoteInformationItem>
        )}

        {quote.company_id == 16 && (
          <>

            {(quote.sub_product === 'vita_privata') && (
              <>
                {quote.quote_massimale
                  && (
                    <QuoteInformationItem>
                      <h6>Massimale:</h6>
                      <p>
                        {new Intl.NumberFormat().format(quote.quote_massimale)}
                        €
                      </p>
                    </QuoteInformationItem>
                  )}
              </>
            )}
          </>
        )}
        {requestInfo.vehicle && requestInfo.vehicle.value !== null && (quote.quote_type === 'furto_incendio' || quote.quote_type === 'eventi_naturali' || quote.quote_type === 'eventi_socio_politici') && (
          <QuoteInformationItem>
            <h6>Valore Veicolo:</h6>
            <p>
              {Number(requestInfo.vehicle.value).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              {' '}
              €
            </p>
          </QuoteInformationItem>
        )}

        {requestInfo.product_id == '11' && quote.company_id === 1001 && quote.quote_type === 'extra_incendio_contenuto' && (
          <>

            <QuoteInformationItem>
              <h6>Massimale:</h6>
              <p>
                Tra &euro; 30,000 e &euro; 500,000
              </p>
            </QuoteInformationItem>

          </>
        )}

        {requestInfo.product_id == '1' && quote.company_id === 1001 && quote.external_quote_data && (
          <>

            {quote.external_quote_data.scoperto_in_rete && (
              <QuoteInformationItem>
                <h6>Scoperto In Rete:</h6>
                <p>{quote.external_quote_data.scoperto_in_rete}</p>
              </QuoteInformationItem>
            )}
            {quote.external_quote_data.franchigia_in_rete && (
              <QuoteInformationItem>
                <h6>Franchigia In Rete:</h6>
                <p>
                  {quote.external_quote_data.franchigia_in_rete}
                  {' '}
                  &euro;
                </p>
              </QuoteInformationItem>
            )}
            {quote.external_quote_data.scoperto_fuori_rete && (
              <QuoteInformationItem>
                <h6>Scoperto Fuori Rete:</h6>
                <p>{quote.external_quote_data.scoperto_fuori_rete}</p>
              </QuoteInformationItem>
            )}
            {quote.external_quote_data.franchigia_fuori_rete && (
              <QuoteInformationItem>
                <h6>Franchigia Fuori Rete:</h6>
                <p>
                  {quote.external_quote_data.franchigia_fuori_rete}
                  {' '}
                  &euro;
                </p>
              </QuoteInformationItem>
            )}

          </>
        )}

        {quote.company_id === 19 && quote.product_id === 1000 && (
          <>
            {quote.quote_type == 'invalidita_permanente_da_infortunio'
              && (

                <QuoteInformationItem>
                  <h6>Franchigia:</h6>
                  <p>
                    3%
                  </p>
                </QuoteInformationItem>

              )}
            {quote.quote_type == 'tutela_legale'
              && (

                <QuoteInformationItem>
                  <h6>Scoperto:</h6>
                  <p>
                    10% con minimo di € 1.500,00
                  </p>
                </QuoteInformationItem>

              )}
          </>
        )}
        {quote.company_id === 1006 && quote.product_id === 1006 && (
          <>

            <QuoteInformationItem>
              <h6>Paccheto:</h6>
              <p>{monopattiniPackage.find((e) => e.id === quote.code).name}</p>
            </QuoteInformationItem>
          </>
        )}

      </QuoteInformationContainer>
    </>
  );
}

export default RiskQuoteInfoComponent;
